export const SEARCH_PAGE_SIZE = 10;
export const SEARCH_MAX_OFFSET = 990;

export interface ParcelSearchResult {
  parcelNumber: string;
  pin: string;
  address: string;
  city: string;
  owner: string;
}

export interface ParcelSearchPage {
  results: ParcelSearchResult[];
  nextOffset: number | null;
  hasMore: boolean;
}

export interface ParcelSearchResponse extends ParcelSearchPage {
  generatedAt: string;
  stale: boolean;
}

export function normalizeSearchQuery(value: string): string {
  return value.replace(/’/g, "'").trim().replace(/\s+/g, ' ').toUpperCase();
}

export function searchQueryError(query: string): string | null {
  if (query.length < 3 || query.length > 80) return 'Enter between 3 and 80 characters.';
  if (query.split(' ').length > 8) return 'Use no more than eight search words.';
  // Keep LIKE wildcards and control characters out of user input. Apostrophes
  // are valid in names and are separately escaped as SQL literals server-side.
  if (!/^[\p{L}\p{N} .'&,/#-]+$/u.test(query) || !/[\p{L}\p{N}]{2}/u.test(query)) {
    return 'Use letters, numbers, spaces, or name/address punctuation.';
  }
  return null;
}
